<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->

<!-- Generating-2.0-report loading screen. Shown for new users whose 2.0   -->
<!-- report is being auto-generated at submit time per Steve 2026-06-11    -->
<!-- item 1. Covers the AI personalization wait (typically 15-30s).        -->
<div *ngIf="generatingArchetypeReport"
     style="position: fixed; inset: 0; background: rgba(255,255,255,0.97); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: var(--z-overlay);">
  <i class="fa fa-magic fa-4x m-b-md" style="color: var(--c-green); animation: pulse 1.5s ease-in-out infinite;"></i>
  <h2 class="font-bold m-t-md m-b-sm" style="color: var(--c-green-deep);">Generating your IPSAT 2.0 Archetype Report</h2>
  <p class="text-muted text-center text-lg" style="max-width: 480px;">
    Your free IPSAT 2.0 personalized report is being prepared based on your
    answers. This usually takes <strong>15-30 seconds</strong>. Please don't refresh the page.
  </p>
  <div class="m-t-md" style="display: flex; gap: 6px;">
    <div class="dot" style="width: 10px; height: 10px; background: var(--c-green); border-radius: 50%; animation: bounce 1.4s infinite ease-in-out;"></div>
    <div class="dot" style="width: 10px; height: 10px; background: var(--c-green); border-radius: 50%; animation: bounce 1.4s infinite ease-in-out 0.2s;"></div>
    <div class="dot" style="width: 10px; height: 10px; background: var(--c-green); border-radius: 50%; animation: bounce 1.4s infinite ease-in-out 0.4s;"></div>
  </div>
</div>

<div class="nexleaderSurveyBox">
  <form (ngSubmit)="submit()">
    <ng-container *ngIf="survey">
      <div *ngFor="let question of survey.questions; let i = index">
        <app-nexleader-survey-question
          [question]="question"
          [index]="i"
        ></app-nexleader-survey-question>
      </div>
    </ng-container>
    <div
      class="nexleaderSurveyQuestionBox nexleaderSurveyFinish nexleaderSurveyText"
      id="survey30"
    >
      <input
        class="nexleaderSurveySubmit"
        type="submit"
        [disabled]="isFormInvalid() || disableSubmit ? true : null"
      />
      <br />
      <span *ngIf="isFormInvalid()"
        >Your IPSAT is not complete, please make sure you've answered all the
        questions.</span
      >
    </div>
  </form>
</div>
